import {NotificationPreferences} from './notifications-preferences';
import {Component, EventEmitter, OnInit, Output, TemplateRef} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators} from '@angular/forms';
import {CommonValidators} from 'src/app/shared/common-components/common-validators';
import {NotificationsPreferencesService} from './notifications-preferences.service';
import {AlertService} from 'src/app/services/alert/alert.service';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {emailsValidator} from './Validators';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {UserService} from '../../services/user/user.service';
import {UserProfileService} from '../../services/user-profile/user-profile.service';
import { TspAgyProfileAuditTrailComponent } from '../tspagy-profile-audit-trail/tspagy-profile-audit-trail.component';
import {ShipmentAuditTrailService} from '../../services/shipment-audit-trail/shipment-audit-trail.service';

@Component({
    selector: 'app-notifications-preferences',
    templateUrl: './notifications-preferences.component.html',
    styleUrls: ['./notifications-preferences.component.css'],
    standalone: false
})
export class NotificationsPreferencesComponent implements OnInit {
  routeParamOrganizationId: number;
  routeParamCarrierId: number;
  routeParamUserId: number;
  routeParamBusinessType: any;
  routeParamScac: any;
  routeParamName: any;
  routeParamRole: any;
  routeParamComingFrom: any;
  routePermissions: any;
  notificationsPreferencesForm: UntypedFormGroup;
  busType: any;
  notifType: any;
  title: any;
  titleText: any;
  orgType: any;
  agyFrtNotifTypes = ['API-Notifications','Book-Shipment', 'User-Profile-Updates'];
  auditorNotifTypes = ['User-Profile-Updates'];
  agyHhgNotifTypes = ['API-Notifications','Book-Shipment', 'User-Profile-Updates', '3080-Notifications'];
  frtNotifTypes = ['Book-Shipment', 'SAM.gov Expiration Notices', 'User-Profile-Updates'];
  // TODO uncomment paygov once ready
  hhgNotifTypes = ['3080-Notifications', 'Book-Shipment', 'HHG or SIT Shipment-Reports - Reminders', 'Pay.gov Notifications', 'SAM.gov Expiration Notices', 'User-Profile-Updates'];
 // hhgNotifTypes = ['Book-Shipment', '3080-Notifications', 'HHG or SIT Shipment-Reports - Reminders', 'SAM.gov Expiration Notices', 'User-Profile-Updates'];
  notifTypes = [];
  showBusType: boolean;
  showNotifType: boolean;
  showDataFields: boolean;
  notifPref: NotificationPreferences;
  modalRef?: BsModalRef;
  pocInfo: any = null;
  notRouted: boolean = false;

  constructor(private router: Router,
              public bsModalRef: BsModalRef,
              private fb: UntypedFormBuilder,
              private route: ActivatedRoute,
              private notifPrefService: NotificationsPreferencesService,
              private alertService: AlertService,
              private tmssLoader: LoadingService,
              private userProfileService: UserProfileService,
              private modalService: BsModalService,
              private shipmentAuditTrailService: ShipmentAuditTrailService) {
  }

  ngOnInit(): void {
    if (!this.notRouted) {
      this.getRouteParams();
    }
    this.titleText = 'Notification Preferences for ' + this.routeParamName;
    this.initFlags();
    this.createForm();
    this.notifPref = new NotificationPreferences();
    this.notifPref.orgId = this.routeParamOrganizationId;
    this.notifPref.orgType = this.orgType;
    this.userProfileService.getUserByOrganizationId(this.routeParamUserId.toString(), this.routeParamOrganizationId.toString()).subscribe(user => {
      this.pocInfo = user.organizationEntity;
    });
  }

  createForm() {
    this.notificationsPreferencesForm = this.fb.group({
      businessType: new UntypedFormControl(''),
      notificationType: new UntypedFormControl(''),
      email: new UntypedFormControl('', [Validators.required, emailsValidator()]),
    });
  }

  getRouteParams() {
    this.routeParamOrganizationId = this.route.snapshot.queryParams['organizationId'];
    this.routeParamUserId = this.route.snapshot.queryParams['userId'];
    this.routeParamName = this.route.snapshot.queryParams['name'];
    this.routeParamComingFrom = this.route.snapshot.queryParams['comingFrom'];
    this.routeParamRole = this.route.snapshot.queryParams['role']; // sysadmin carrierAdmin agencyAdmin
    this.routePermissions = this.route.snapshot.queryParams['permissions']; // HHG FRT  HHG & FRT
  }

  initFlags() {
    this.showBusType = false;
    this.showNotifType = true;
    this.showDataFields = false;
    this.title = this.titleText;
    if (this.routePermissions == 'HHG & FRT') {
      this.showBusType = true;
      this.showNotifType = false;
    }
    if (!this.showBusType) {
      this.busType = this.routePermissions;
      this.title = this.busType + ' ' + this.titleText;
    }
    this.orgType = 'TSP';
    if (this.routeParamRole == 'agencyAdmin') {
      this.orgType = 'Agency';
      if (this.routePermissions == 'FRT') {
        this.notifTypes = this.agyFrtNotifTypes;
      } else {
        this.notifTypes = this.agyHhgNotifTypes;
      }

    } else if (this.routeParamRole == 'agencyAuditor') {
      this.orgType = 'AgencyAuditor';
      this.notifTypes = this.auditorNotifTypes;

    } else {
      if ((this.routePermissions == 'FRT') || (this.routePermissions == 'HHG')) {
        if (this.routePermissions == 'FRT') {
          this.notifTypes = this.frtNotifTypes;
        } else {
          this.notifTypes = this.hhgNotifTypes;
        }
      }
    }
  }

// below method is executed for business type change event
  businessTypeChange(event: any) {
    this.busType = event;
    this.title = this.busType + ' ' + this.titleText;
    this.showNotifType = true;
    this.showDataFields = false;
    this.notificationsPreferencesForm.get('notificationType').setValue('');
    if (this.orgType == 'TSP') {
      if (event == 'FRT') {
        this.notifTypes = this.frtNotifTypes;
      } else {
        this.notifTypes = this.hhgNotifTypes;
      }
    } else if (this.orgType == 'AgencyAuditor') {

        this.notifTypes = this.auditorNotifTypes;

    } else {
      if (event == 'FRT') {
        this.notifTypes = this.agyFrtNotifTypes;
      } else {
        this.notifTypes = this.agyHhgNotifTypes;
      }
    }

    this.notifPref.busType = event;
  }

// below method is executed for notification type change event
  notificationTypeChange(event: any) {
    this.notifPref.notifType = event;
    this.notifType = event;
    this.showDataFields = true;
    this.getNotifyPref();

  }

  getNotifyPref() {
    this.notifPrefService.getNotifPref(this.routeParamOrganizationId, this.busType,
      this.orgType, this.notifType)
      .subscribe(data => {
        this.notifPref = data;
        this.setScreenFields();
      });
  }

  setScreenFields() {
    //this.notificationsPreferencesForm.get('firstName').setValue(this.notifPref.firstName);
    //this.notificationsPreferencesForm.get('middleInitial').setValue(this.notifPref.mi);
    //this.notificationsPreferencesForm.get('lastName').setValue(this.notifPref.lastName);
    //this.notificationsPreferencesForm.get('phone').setValue(this.notifPref.phone);
    //this.notificationsPreferencesForm.get('phoneExt').setValue(this.notifPref.phoneExt);
    this.notificationsPreferencesForm.get('email').setValue(this.notifPref.email);
  }

  saveNotifPrefs() {
    this.setPayload();
    this.tmssLoader.show();
    this.notifPrefService.saveNotifPref(this.notifPref)
      .subscribe(result => {
          console.log('success save notifications preferences');
          this.alertService.success('Successfully saved notifications preferences');

          this.tmssLoader.hide();
        },
        error => {
          console.log(error);
          console.log('error in updating notifications preferences');
          this.alertService.error('error in updating notifications preferences');
          this.tmssLoader.hide();
        });
  }

  setPayload() {
    //this.notifPref.firstName = this.notificationsPreferencesForm.get('firstName').value;
    //this.notifPref.lastName = this.notificationsPreferencesForm.get('lastName').value;
    //this.notifPref.mi = this.notificationsPreferencesForm.get('middleInitial').value;
    //this.notifPref.phone = this.notificationsPreferencesForm.get('phone').value;
    //this.notifPref.phoneExt = this.notificationsPreferencesForm.get('phoneExt').value;
    this.notifPref.email = this.notificationsPreferencesForm.get('email').value;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      backdrop: false,
      ignoreBackdropClick: true
    });
  }

  auditTrailLogList: any;
  onViewAuditTrail(){
    const updateProgram = "NotificationPreferences";
    this.tmssLoader.show();
    this.shipmentAuditTrailService.getAuditTrailListByOrgIdAndUpdateProgram(this.routeParamOrganizationId, updateProgram) .subscribe(
      (data:any) => {
        if(data){
          this.auditTrailLogList = data;
          this.tmssLoader.hide();
          const initialState: any = {
            auditTrailLogList: this.auditTrailLogList,
            profile: updateProgram
          };
          this.modalRef = this.modalService.show(TspAgyProfileAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
        }
      },(error:any)=> {
        console.log('There was an error retrieving auditTrailLog records');
        this.tmssLoader.hide();
        this.alertService.error('There was an error retrieving auditTrailLog records');
      }
    )
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}
